import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LegalShell = ({ eyebrow, title, children }) => {
  return (
    <div className="min-h-screen bg-[#050505] text-white grain">
      <div className="max-w-3xl mx-auto px-6 md:px-10 pt-24 md:pt-32 pb-24">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-white/40 hover:text-[#c88a53] transition-colors mb-12"
        >
          <ArrowLeft size={14} /> Zurück
        </Link>

        <span className="label-eyebrow">{eyebrow}</span>
        <h1 className="font-heading mt-6 text-4xl md:text-5xl font-light tracking-tighter leading-[1.05]">
          {title}
        </h1>

        <div className="rule mt-12 mw-line" />

        <div className="mt-12 space-y-10 text-[0.95rem] text-white/65 leading-relaxed font-light">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LegalShell;
